import React, { FC }                                            from 'react';
import { FadeContainer, StyledContainer, StyledContainerProps } from '../../../containers';
import { CorvalUIColor, Position, SemanticUIColor, Size }       from '../../../../types';
import { Header, Icon, Popup, PopupProps, SemanticCOLORS }      from 'semantic-ui-react';
import { HexagonShape }                                         from '../visual/HexagonShape';


interface ToolTipProps {
    content: any,
    size?: number
    color?: SemanticUIColor | CorvalUIColor,
    inverted?: boolean,
    popupProps?: PopupProps,
    containerProps?: StyledContainerProps,
}

const defaultProps: ToolTipProps = {
    size:           14,
    content:        '',
    color:          SemanticUIColor.PURPLE,
    inverted:       true,
    popupProps:     {
        size:     'small',
        position: 'top center',
        on:       [ 'hover', 'focus' ],
    },
    containerProps: {
        margin:    [ null, Size.XS ],
        textColor: SemanticUIColor.PURPLE,
        className: 'opacity--75 opacity-hover--100 display--inline-block cursor--pointer'
    },
}

const Tooltip: FC<ToolTipProps> = ( props ) => {

    let tooltipSize = props.size;

    let popupProps     = { ...defaultProps.popupProps, ...props.popupProps },
        containerProps = { ...defaultProps.containerProps, ...props.containerProps };

    return (

        <Popup { ...popupProps }
               content={ props.content }
               trigger={
                   <StyledContainer { ...containerProps } position={ Position.RELATIVE } style={ { width: tooltipSize, height: tooltipSize } }>
                       <FadeContainer>
                           <HexagonShape size={ tooltipSize } color={ props.inverted ? props.color : CorvalUIColor.WHITE }>
                               <StyledContainer position={ Position.ABSOLUTE } top left right bottom style={ { display: 'flex', justifyContent: 'center', alignItems: 'center' } }>
                                   <Icon name={ 'question' } inverted={ props.inverted } color={ ( props.inverted ? null : props.color ) as SemanticUIColor } fitted size={ 'tiny' }/>
                               </StyledContainer>
                           </HexagonShape>
                       </FadeContainer>
                   </StyledContainer>
               }/>
    );
};

Tooltip.defaultProps = defaultProps;

const CategoryDescTooltip: FC<ToolTipProps> = ( props ) => (
    <Tooltip { ...props } content={ (
        <>
            <Header as={ 'h6' } content={ 'About this Category' }/>
            <p>{ props.content }</p>
        </>
    ) }/>
)

export { Tooltip, type ToolTipProps, CategoryDescTooltip }
